import { defineBoot } from '#q-app';
import { Dark } from 'quasar';

import { usePreferencesStore } from 'src/stores/usePreferencesStore';

import { DarkModes } from 'src/constants/app';
// TODO: This is probably not the best way to do it. We should maybe use a computed property in the store. or a watch on interface.darkMode in App.vue
export function setDarkMode() {
  const preferences = usePreferencesStore();
  if (preferences.interface.darkMode === DarkModes.DARK) {
    Dark.set(true);
  } else if (
    preferences.interface.darkMode === DarkModes.BROWSER &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    Dark.set(true);
  } else {
    Dark.set(false);
  }
}

export default defineBoot(() => {
  setDarkMode();
});
